// 保护路由

import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Typography, Button, Alert, Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import LockIcon from "@mui/icons-material/Lock";

// 样式化组件
const LoginContainer = styled(Box)`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("/images/bg-pattern.jpg") no-repeat center center;
  background-size: cover;
  padding: 24px;
`;

const GlassCard = styled(Box)`
  background: rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-radius: 24px;
  padding: 48px;
  width: 100%;
  max-width: 480px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 24px;
    pointer-events: none;
  }
`;

const IconWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  borderRadius: "50%",
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
  color: "#fff",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: 64,
  height: 64,
  margin: "0 auto 24px",
  position: "relative",
  zIndex: 1,
}));

const ActionButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(3),
  padding: theme.spacing(1.5, 4),
  borderRadius: 8,
  fontWeight: 600,
  textTransform: "none",
  fontSize: "1rem",
  boxShadow: "none",
}));

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLoginClick = () => {
    navigate("/login");
  };

  // 如果已登录，渲染子组件
  if (isLoggedIn) {
    return children;
  }

  // 如果未登录，显示毛玻璃效果的提示信息
  return (
    <LoginContainer>
      <GlassCard>
        <IconWrapper>
          <LockIcon fontSize="large" />
        </IconWrapper>

        <Typography
          variant="h5"
          component="h1"
          gutterBottom
          sx={{
            textAlign: "center",
            fontWeight: 600,
            color: "#fff",
            textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
            mb: 3,
            position: "relative",
            zIndex: 1,
          }}
        >
          需要登录
        </Typography>

        <Alert
          severity="info"
          sx={{
            width: "100%",
            my: 2,
            borderRadius: 2,
            backgroundColor: "rgba(33, 150, 243, 0.2)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            "& .MuiAlert-message": { color: "#fff" },
            "& .MuiAlert-icon": { color: "#fff" },
            position: "relative",
            zIndex: 1,
          }}
        >
          您正在尝试访问需要管理员权限的页面
        </Alert>

        <Typography
          variant="body1"
          align="center"
          sx={{
            mb: 2,
            color: "#fff",
            textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
            lineHeight: 1.6,
            position: "relative",
            zIndex: 1,
          }}
        >
          请先登录管理员账号后再访问此页面。如果您没有管理员账号，请联系系统管理员。
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2,
            position: "relative",
            zIndex: 1,
          }}
        >
          <ActionButton
            variant="contained"
            color="primary"
            onClick={handleLoginClick}
            sx={{
              background: "rgba(255, 255, 255, 0.2)",
              color: "#fff",
              backdropFilter: "blur(6px)",
              WebkitBackdropFilter: "blur(6px)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              "&:hover": {
                background: "rgba(255, 255, 255, 0.25)",
              },
            }}
          >
            前往登录
          </ActionButton>
        </Box>

        <Typography
          variant="body2"
          sx={{
            mt: 4,
            textAlign: "center",
            color: "rgba(255, 255, 255, 0.7)",
            textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
            fontSize: "0.85rem",
            position: "relative",
            zIndex: 1,
          }}
        >
          © 2024 教会管理系统 | 版权所有
        </Typography>
      </GlassCard>
    </LoginContainer>
  );
};

export default ProtectedRoute;
